import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Table from '../Table/Table'
// import Cards from '../Cards/Cards';
import { Body } from '../Shell/Shell'
// import ActionButton, { ActionButtonGroup } from '../ActionButton/ActionButton';
import { Spinner } from '../Loaders/Loaders'
import { SEARCH, GET_LIENS_SEARCH_WEB_CART } from '../../requests'
import {
  setResults,
  selectRow,
  setResultsMode,
  toggleSearching,
  setSort,
  setActiveCategory,
  getSearchDescription,
  setSearchError,
  clearSearchError,
} from './SearchActions'
import PrintIcon from '@tecuity/sos-icons/react/print-solid'
import RecordDrawer from 'components/RecordDrawer/RecordDrawer'
import ReactMarkdown from 'components/Markdown/Markdown'
import {
  getOrderedResultsByCategory,
  calculateReceiptItemsTotal,
  parseUrlQuery,
  calculateReceiptItemContainersTotal,
} from 'utilities'
import { SUBROUTES_OBJ } from '../../App'
import AdvancedParameters from './AdvancedParameters'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Portal from 'components/Portal/Portal'
import ConnectedCheckout from 'components/Checkout/Checkout'
import './Search.scss'
import Pager from '../Pager/Pager'
import EmptySearchPlaceholder from './EmptySearchPlaceholder'
import SearchError from './SearchError'

const SEARCH_HAS_PAGINATION = process.env.SEARCH_HAS_PAGINATION

export class Search extends Component {
  constructor() {
    super()
    this.state = {
      ownershipModalOpen: false,
      requestOwnershipModal: false,
      pinsModalOpen: false,
      amendmentLauncherOpen: false,
      webcart: null,
      checkoutOpen: false,
    }
  }
  componentDidMount = () => {
    if (this.props.match.params.subParam) {
      if (!SUBROUTES_OBJ[this.props.match.params.subParam]) {
        this.props.history.replace('/404')
      } else if (
        SUBROUTES_OBJ[this.props.match.params.subParam].serverWebSearchDescription &&
        !this.props.serverDescription
      ) {
        this.props.getSearchDescription(this.props.match.params.subParam)
      }
      this.props.clearSearchError(this.props.match.params.subParam)
    }
  }
  componentWillReceiveProps = (nextProps) => {
    const categoryHasChanged = this.props.match.params.subParam !== nextProps.match.params.subParam
    if (categoryHasChanged) {
      if (!SUBROUTES_OBJ[nextProps.match.params.subParam]) {
        this.props.history.replace('/404')
      } else if (
        SUBROUTES_OBJ[nextProps.match.params.subParam].serverWebSearchDescription &&
        !nextProps.serverDescription
      ) {
        this.props.getSearchDescription(nextProps.match.params.subParam)
      }
      const previousCategoryWasNotValid =
        !this.props.match.params.subParam && nextProps.match.params.subParam
      if (previousCategoryWasNotValid) {
        this.props.clearSearchError(nextProps.match.params.subParam)
      }
      this.props.setActiveCategory(nextProps.match.params.subParam)
    }
  }
  // onBodyResize = ({width, height}) => {
  //   if(width < 500 && this.props.resultsMode === "table"){
  //     this.props.setResultsMode("cards")
  //   }else if(width >= 500 && this.props.resultsMode === "cards"){
  //     this.props.setResultsMode("table")
  //   }
  // }
  selectRow = (row) => {
    this.props.selectRow(this.props.match.params.subParam, row.ID)
  }
  setResults = (results, searchValue) => {
    this.props.setResults(results, this.props.match.params.subParam, searchValue)
    this.props.selectRow(this.props.match.params.subParam, null)
    if (
      this.props.isMobile &&
      this.props.orderedResults.rows &&
      this.props.orderedResults.rows.length > 0
    ) {
      window.scrollTo(0, this.searchResultsRef.offsetTop - 20)
    }
  }
  
  setSort = (e, sortId) => {
    return this.props.setSort({
      category: this.props.match.params.subParam || 'Record Type',
      sortBy: sortId,
      sortByDirection: this.props.sortBy === sortId
          ? (this.props.sortByDirection === 'DESC' ? 'ASC' : 'DESC')
          : 'DESC',
    }).then(() => this.searchTrigger(e, this.props));
  }

  formatForCards = (header, rows) => {
    let cards = rows.map((row, i) => ({
      title: row.CELLS[0],
      alert: row.ALERT_YN,
      details: this.formatRowDetails(header, row.CELLS),
      recordId: row.RECORD_ID,
    }))
    return cards
  }
  onSidebarDismiss = () => {
    this.props.selectRow(this.props.match.params.subParam, null)
  }
  startLiensCheckout = (searchTerm, advancedParameters) => {
    GET_LIENS_SEARCH_WEB_CART(
      {
        searchTerm,
        advancedParameters,
        searchResults: this.props.orderedResults.rows.map((row) => row.ID),
      },
      ({ RECEIPT_ITEM_WEB_LIST, RECEIPT_ITEM_CONTAINER_WEB_LIST, REF_NUM }) => {
        const total = RECEIPT_ITEM_CONTAINER_WEB_LIST
          ? calculateReceiptItemContainersTotal(RECEIPT_ITEM_CONTAINER_WEB_LIST)
          : calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)
        this.setState(
          {
            webcart: {
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
              refNum: REF_NUM,
            },
            checkoutOpen: total > 0,
          },
          () => {
            if (total <= 0) {
              this.openReceipt()
            }
          }
        )
      },
      (err) => {
        console.error(err)
      }
    )
  }
  closeCheckout = () => {
    this.setState({ checkoutOpen: false })
  }
  cancelCheckout = () => {
    this.slider.closeSlider(() => {
      this.setState({ checkoutOpen: false, webcart: null })
    })
  }
  openReceipt = (refNum) => {
    // this.disablePaymentButtons()
    // this.getRecords(this.props.match.params.category, () => {
    //   this.enablePaymentButtons()
    // })
    if (this.slider) {
      this.slider.closeSlider(() => {
        // this.setState({checkoutOpen: false})
        this.props.history.push(`/receipt?ref=${refNum || this.state.webcart.refNum}`)
      })
    } else {
      this.props.history.push(`/receipt?ref=${refNum || this.state.webcart.refNum}`)
    }
  }
  getPagerProps = () => {
    const { offset, limit, total } = this.props.edge
    const numPages = Math.ceil(total / limit)
    const activePage = Math.ceil(offset / limit) + 1
    return { numPages, activePage }
  }
  onPrevClicked = (event) => {
    const { offset, limit } = this.props.edge
    this.searchTrigger(event, { offset: offset - limit })
  }
  onPageClicked = (event, activePage) => {
    const { limit } = this.props.edge
    this.searchTrigger(event, {offset: activePage * limit - limit})
  }
  onNextClicked = (event) => {
    const { offset, limit } = this.props.edge
    this.searchTrigger(event, { offset: offset + limit })
  }
  searchTrigger = null

  searchResultsRef = null

  renderResults(props, sublink) {
    if (props.searchError) {
      return props.searching ? null : (
        <SearchError title={props.searchError.title} message={props.searchError.message} />
      )
    } else if (
      props.orderedResults.rows &&
      props.orderedResults.rows.length > 0 &&
      !props.isStale
    ) {
      let headerClickedFunction = null
      if (props.onHeaderLabelClicked) {
        headerClickedFunction = props.onHeaderLabelClicked
      } else if (process.env.SEARCH_IS_SORTABLE || sublink.searchIsSortable) {
        headerClickedFunction = this.setSort
      }

      return (
        <React.Fragment>
          {(SEARCH_HAS_PAGINATION || sublink.searchHasPagination) &&
          props.orderedResults.rows &&
          props.orderedResults.rows.length > 1 ? (
              <Pager
                  {...this.getPagerProps()}
                  onPrevClicked={this.onPrevClicked}
                  onPageClicked={this.onPageClicked}
                  onNextClicked={this.onNextClicked}
              />
          ) : null}
          <div className="table-wrapper">
            <Table
              template={props.orderedResults.template}
              rows={props.orderedResults.rows}
              className="center-container"
              onCellClick={this.selectRow}
              selectedRowIndex={
                props.orderedResults.rows
                  ? props.orderedResults.rows.findIndex((row) => row.ID === props.selectedId)
                  : false
              }
              animated={false}
              sortable={
                props.sortable || sublink.searchIsSortable || process.env.SEARCH_IS_SORTABLE
              }
              sortBy={props.sortBy}
              
              sortByDirection={props.sortByDirection}
              onHeaderLabelClicked={headerClickedFunction}
              rowCount
              firstCellInteractive={props.firstCellInteractive}
              totalRows={
                SEARCH_HAS_PAGINATION || sublink.searchHasPagination ? props.edge.total : null
              }
              innerRef={(ref) => (this.searchResultsRef = ref)}
            />
          </div>
          {(SEARCH_HAS_PAGINATION || sublink.searchHasPagination) &&
          props.orderedResults.rows &&
          props.orderedResults.rows.length > 1 ? (
            <Pager
              {...this.getPagerProps()}
              onPrevClicked={this.onPrevClicked}
              onPageClicked={this.onPageClicked}
              onNextClicked={this.onNextClicked}
            />
          ) : null}
        </React.Fragment>
      )
    } else if (props.orderedResults.rows && props.orderedResults.rows.length == 0) {
      return <EmptySearchPlaceholder searchTerm={props.currentSearchTerm} />
    } else if (props.searching) {
      return <Spinner className="search-loader" />
    } else {
      return null
    }
  }

  render() {
    const {
      orderedResults,
      results,
      // resultsMode = "table",
      // isMobile,
      selectedId,
      activeCategory,
      sublinks,
      allowEmptySearchTerm,
      sortBy,
      sortByDirection,
      sortable,
      getSearchTrigger,
      aboveSearchChildren,
      serverDescription,
      isStale,
    } = this.props
    const category = this.props.match.params.subParam
    const selectedResult = results[selectedId]
    const selectedTitle = selectedResult ? selectedResult.TITLE[0] : ''
    const selectedSubtitle = selectedResult ? selectedResult.TITLE[1] : ''
    const sublink = sublinks.find((l) => l.parameter === category) || {}
    const showSearchLiensCheckout = sublink.searchLiensCheckout === true
    const allowSearchPrint = sublink.allowSearchPrint === true

    if (!this.props.match.params.subParam) {
      let curLocation = this.props.location.pathname
      curLocation = curLocation.replace(/\/+$/, '')
      let url = `${curLocation}/${activeCategory ? activeCategory : sublinks[0].parameter}`
      return <Redirect to={url} />
    } else if (!sublink.parameter) {
      return <Redirect to={`/search/${sublinks[0].parameter}`} />
    } else {
      return (
        <Body className="search" showDrawer={selectedId}>
          {aboveSearchChildren}
          {sublink.serverWebSearchDescription && serverDescription === null ? (
            <div className="flex-center-page">
              <Spinner className="animated fadeIn" themeColor="neutral" />
            </div>
          ) : (
            <React.Fragment>
              <ConnectedSearchBox
                title={`${sublink.label || ''} Search`}
                showSearchLiensCheckout={showSearchLiensCheckout}
                allowSearchPrint={allowSearchPrint}
                placeholder={
                  sublink.searchPlaceholder ||
                  process.env.DEFAULT_SEARCH_PLACEHOLDER ||
                  `Search by name or ${process.env.SYSTEM_ID_LABEL.toLowerCase()} (###-#####)`
                }
                onResultsReceived={this.setResults}
                category={category}
                advancedParameters={sublink.advancedSearchParameters}
                searchRequirementsAreSatisfied={sublink.searchRequirementsAreSatisfied}
                description={serverDescription || sublink.searchDescription || ""}
                limitDescription={sublink.limitDescription}
                hasResults={orderedResults.rows && orderedResults.rows.length > 0}
                onPurchaseRequested={showSearchLiensCheckout ? this.startLiensCheckout : null}
                allowEmptySearchTerm={allowEmptySearchTerm || sublink.allowEmptySearchTerm}
                sortable={sortable || sublink.searchIsSortable || process.env.SEARCH_IS_SORTABLE}
                sortBy={sortBy}
                sortByDirection={sortByDirection}
                searchMustHaveOneOf={sublink.searchMustHaveOneOf}
                longDescriptionSearchPage={sublink.longDescriptionSearchPage}
                minimumSearchCharacters={sublink.minimumSearchCharacters}
                advancedParametersStartOpen={sublink.advancedParametersStartOpen}
                isStale={isStale}
                getSearchTrigger={(trigger) => {
                  if (getSearchTrigger) getSearchTrigger(trigger)
                  this.searchTrigger = trigger
                }}
                history={this.props.history}
              />

              {this.renderResults(this.props, sublink)}
            </React.Fragment>
          )}
          <RecordDrawer
            show={selectedId}
            title={selectedTitle}
            subtitle={selectedSubtitle}
            category={category}
            sourceId={selectedResult && selectedResult.ID}
            recordNum={selectedResult && selectedResult.RECORD_NUM}
            canFileAR={selectedResult && selectedResult.CAN_FILE_AR}
            canAlwaysFileAR={selectedResult && selectedResult.CAN_ALWAYS_FILE_AR}
            canReinstate={selectedResult && selectedResult.CAN_REINSTATE}
            canFileReinstatement={selectedResult && selectedResult.CAN_FILE_REINSTATEMENT}
            sublink={sublink}
            onSidebarDismiss={this.onSidebarDismiss}
            uccFilingID={selectedResult && selectedResult.UCC_FILING_ID}
            uccDebtorID={selectedResult && selectedResult.UCC_DEBTOR_ID}
            uccSecuredPartyID={selectedResult && selectedResult.UCC_SECURED_PARTY_ID}
            uccEfsProductID={selectedResult && selectedResult.UCC_EFS_PRODUCT_ID}
          />
          <Portal isOpened={this.state.checkoutOpen}>
            <SlidingPanel
              closeOnShadeClick={false}
              closeSlider={this.closeCheckout}
              ref={(ref) => {
                this.slider = ref
              }}
            >
              <ConnectedCheckout
                cancelCheckout={this.cancelCheckout}
                closeModal={this.closeCheckout}
                redirectToReceipt={this.openReceipt}
                amendmentNum={this.state.checkoutOpen && this.state.webcart.amendmentNum}
                refNum={this.state.checkoutOpen && this.state.webcart.refNum}
                formDefinitionId={this.state.checkoutOpen && this.state.webcart.formDefinitionId}
                category={this.props.match.params.category}
                receiptItems={this.state.checkoutOpen && this.state.webcart.receiptItems}
                receiptItemContainers={
                  this.state.checkoutOpen && this.state.webcart.receiptItemContainers
                }
              />
            </SlidingPanel>
          </Portal>
        </Body>
      )
    }
  }
}
export default connect(
  (state, props) => ({
    results:
      props.match.params.subParam && state.search.results
        ? state.search.results[props.match.params.subParam]
          ? state.search.results[props.match.params.subParam]
          : {}
        : {},
    orderedResults:
      props.match.params.subParam &&
      state.search.results &&
      state.search.results[props.match.params.subParam]
        ? getOrderedResultsByCategory(
            props.match.params.subParam,
            state.search.results,
            state.search.templates
          )
        : [],
    edge:
      (props.match.params.subParam && state.search.results
        ? state.search.edges[props.match.params.subParam]
        : {}) || {},
    serverDescription:
      (props.match.params.subParam && state.search.descriptions[props.match.params.subParam]) || '',
    searching: state.search.searching,
    selectedId: props.match.params.subParam
      ? state.search.selected[props.match.params.subParam]
      : null,
    resultsMode: state.search.resultsMode,
    isMobile: state.app.isMobile,
    activeCategory: state.search.activeCategory || state.app.currentCategory,
    sortBy: props.sortBy
      ? props.sortBy
      : (state.search.sorts[props.match.params.subParam] || {}).sortBy,
    sortByDirection: props.sortByDirection
      ? props.sortByDirection
      : (state.search.sorts[props.match.params.subParam] || {}).sortByDirection,
    currentSearchTerm:
      props.match.params.subParam && state.search.searchValueCache
        ? state.search.searchValueCache[props.match.params.subParam]
        : '',
    searchError: state.search.searchError[props.match.params.subParam],
    isStale: state.search.stales[props.match.params.subParam] || false,
  }),
  {
    setResults,
    selectRow,
    setResultsMode,
    setActiveCategory,
    setSort,
    getSearchDescription,
    clearSearchError,
  }
)(Search)

export class ConnectedSearchBox extends Component {
  printWindow = null
  resultsCache = null
  componentDidMount = () => {
    if (!this.props.prefilledSearch) {
      this.setSearchValue(this.props.searchValueCache[this.props.category])
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (this.props.category !== nextProps.category) {
      this.setSearchValue(this.props.searchValueCache[nextProps.category])
    }
  }
  setSearchValue = (value) => {
    this.searchBox.setValue(value)
  }
  componentWillUnmount = () => {
    delete window.onPrintPageReady
  }
  renderPrintPage = (results) => {
    window.onPrintPageReady = this.sendResultsToPrintPage
    this.resultsCache = results
    this.printWindow = window.open('/print-results', 'Print Results')
  }
  sendResultsToPrintPage = () => {
    this.printWindow.setPrintResults(this.resultsCache)
  }
  triggerSearch = (event, searchProps) => this.searchBox.search(event, searchProps)
  getSearchRequirementsFulfilled = (search, parameters) => {
    if (this.props.searchRequirementsAreSatisfied) {
      return this.props.searchRequirementsAreSatisfied(search, parameters)
    }
    const { searchMustHaveOneOf } = this.props
    const parametersConfig = this.props.advancedParameters.reduce((obj, param) => {
      obj[param.name] = param
      return obj
    }, {})
    if (searchMustHaveOneOf.includes('search')) {
      if (search !== '') {
        return true
      }
    }
    return searchMustHaveOneOf
      .filter((key) => key !== 'search')
      .some((key) => {
        const param = parameters[key]
        const config = parametersConfig[key]
        switch (config.type) {
          case 'dateRange':
            return param.start || param.end
          default:
            switch (typeof param) {
              case 'string':
                return param !== '' && param !== '0'
              case 'object':
                if (Array.isArray(param)) {
                  return param.length > 0
                }
                return true
              default:
                return true
            }
        }
      })
  }
  search = (value, parameters) => {
    const meetsMinimumSearchChars = this.props.minimumSearchCharacters
      ? value.trim().length >= this.props.minimumSearchCharacters
      : true

    const meetsSearchMustHaveOneOf =
      this.props.searchMustHaveOneOf !== undefined
        ? this.getSearchRequirementsFulfilled(value, parameters)
        : true

    const validSearch =
      (value || this.props.allowEmptySearchTerm) &&
      (meetsMinimumSearchChars || this.props.allowEmptySearchTerm) &&
      meetsSearchMustHaveOneOf

    if (
      this.props.searchRequirementsAreSatisfied
        ? this.props.searchRequirementsAreSatisfied(value, parameters)
        : validSearch
    ) {
      this.props.toggleSearching(true)
      this.props.setSearchError(null)
      
      const sortingParameters =
        this.props.sortable && this.props.sortBy
          ? { SORT_BY_ID: this.props.sortBy, SORT_BY_DIRECTION: this.props.sortByDirection }
          : {}
      SEARCH(
        { SEARCH_VALUE: value, ...parameters, ...sortingParameters },
        this.props.category,
        (results) => {
          this.props.clearSearchError(this.props.category)
          this.props.toggleSearching(false)
          if (parameters.PRINT) {
            this.renderPrintPage(results)
          } else {
            this.props.onResultsReceived(results, value)
          }
        },
        (err = {}) => {
          console.error(err)
          this.props.setSearchError(
            {
              title: err.title,
              message: err.message,
            },
            this.props.category
          )
          this.props.toggleSearching(false)
        }
      )
    } else {
      console.error('Invalid Search')
    }
  }
  render() {
    const { getSearchTrigger, allowEmptySearchTerm, advancedParametersStartOpen, isStale } =
      this.props

    if (getSearchTrigger) {
      getSearchTrigger(this.triggerSearch)
    }
    return (
      <SearchBox
        ref={(ref) => {
          this.searchBox = ref
        }}
        category={this.props.category}
        title={this.props.title}
        placeholder={this.props.placeholder}
        search={this.search}
        searching={this.props.searching}
        advancedParameters={this.props.advancedParameters}
        description={this.props.description}
        limitDescription={this.props.limitDescription}
        showSearchLiensCheckout={this.props.showSearchLiensCheckout}
        allowSearchPrint={this.props.allowSearchPrint}
        hasResults={this.props.hasResults}
        onPurchaseRequested={this.props.onPurchaseRequested}
        loggedIn={this.props.loggedIn}
        allowEmptySearchTerm={allowEmptySearchTerm}
        advancedParametersStartOpen={advancedParametersStartOpen}
        searchRequirementsAreSatisfied={this.props.searchRequirementsAreSatisfied}
        minimumSearchCharacters={this.props.minimumSearchCharacters}
        isStale={isStale}
        defaultValue={this.props.prefilledSearch}
        key={this.props.category}
        searchMustHaveOneOf={this.props.searchMustHaveOneOf}
        longDescriptionSearchPage={this.props.longDescriptionSearchPage}
      />
    )
  }
}
ConnectedSearchBox = connect(
  (state) => ({
    searching: state.search.searching,
    searchValueCache: state.search.searchValueCache,
    loggedIn: state.auth.loggedIn,
    location: state.router.location,
    prefilledSearch: parseUrlQuery(state.router.location.search).prefill,
  }),
  { toggleSearching, setSearchError, clearSearchError }
)(ConnectedSearchBox)

export class SearchBox extends Component {
  getDefaultValues = (parameters) =>
    parameters.reduce((obj, param) => ({ ...obj, [param.name]: param.defaultValue }), {})
  state = {
    drawerIsOpen: this.props.advancedParametersStartOpen ? true : false,
    hasValue: false,
    inputValue: '',
    advancedParameterValues: this.getDefaultValues(this.props.advancedParameters),
  }
  componentDidMount = () => {
    this.input.focus()
    this.checkForStaleSearch(this.props)
  }
  componentDidUpdate = () => {
    this.checkForStaleSearch(this.props)
  }
  checkForStaleSearch = (props) => {
    if (props.isStale) {
      this.search()
    }
  }
  selectSearch = () => {
    this.input.select()
  }
  setValue = (value) => {
    this.input.value = value
    this.setState({ hasValue: !!value.length })
  }
  search = (event, { offset, print } = {}) => {
    if (!event) return

    event.preventDefault()

    if (!this.props.searching) {
      let parameters = {}
      if (this.parameters) {
        parameters = this.state.advancedParameterValues
      }
      parameters.OFFSET = offset
      parameters.PRINT = print
      this.props.search(this.input.value || '', parameters)
    }
  }
  trimValue = (e) => {
    if (e.target.value.length >= 50) {
      this.input.value = e.target.value.slice(0, 49)
    }
    this.setState({ hasValue: !!e.target.value.length, inputValue: e.target.value })
  }
  clearFilters = () => {
    this.setState({ advancedParameterValues: this.getDefaultValues(this.props.advancedParameters) })
  }
  setAdvanceParameterValues = (values) => this.setState({ advancedParameterValues: values })
  render() {
    const {
      title = 'Search',
      placeholder,
      searching,
      category,
      advancedParameters,
      description,
      limitDescription,
      showSearchLiensCheckout,
      allowSearchPrint,
      hasResults,
      onPurchaseRequested,
      allowEmptySearchTerm,
      advancedParametersStartOpen,
      minimumSearchCharacters,
      searchRequirementsAreSatisfied,
      loggedIn,
      defaultValue,
      searchMustHaveOneOf,
      longDescriptionSearchPage,
    } = this.props

    // Boolean to determine whether the main search can be overriden by certain fields and if they have values with more characters than the minimumSearchCharacters state config
    // const searchOverrideSatisfied = !allowEmptySearchTerm ? false : searchMustHaveOneOf.some(param =>(
    //     typeof this.state.advancedParameterValues[param] == 'object' ? Object.values(this.state.advancedParameterValues[param]).some(value => value !== '') : (this.state.advancedParameterValues[param] && this.state.advancedParameterValues[param].value !== (advancedParameters.find(advParam => advParam.name === param).defaultValue || !this.state.advancedParameterValues[param]) )
    //   )
    // )

    const searchOverrideSatisfied =
      this.state.advancedParameterValues.SEARCH_TYPE_ID !== '2' || !allowEmptySearchTerm
        ? false
        : searchMustHaveOneOf.some((param) => {
            const advParam = advancedParameters.find((advParam) => advParam.name === param)
            const paramValue = this.state.advancedParameterValues[param]
            const valuesEqual =
              typeof paramValue === 'object'
                ? JSON.stringify(advParam.defaultValue) === JSON.stringify(paramValue)
                : advParam && advParam.defaultValue === this.state.advancedParameterValues[param]
            // console.log('param: ' + param + '\n',
            //             'value: ' + this.state.advancedParameterValues[param] + '\n',
            //             'advParam.defaultValue: ' + (advParam && advParam.defaultValue) + '\n',
            //             'valuesEqual: ' + valuesEqual)
            //return typeof this.state.advancedParameterValues[param] == 'object' ? Object.values(this.state.advancedParameterValues[param]).some(value => value !== '') : (this.state.advancedParameterValues[param] && this.state.advancedParameterValues[param].value !== (advParam.defaultValue || '' || null) )
            return !valuesEqual
          })

    // console.log('searchOverrideSatisfied: ' + searchOverrideSatisfied)

    const mainSearchDisabled = searchRequirementsAreSatisfied
      ? !searchRequirementsAreSatisfied(this.state.inputValue, this.state.advancedParameterValues)
      : (minimumSearchCharacters
          ? this.state.inputValue.trim().length < minimumSearchCharacters
          : false) || (allowEmptySearchTerm ? false : !this.state.hasValue)

    const searchDisabled =
      this.state.advancedParameterValues.SEARCH_TYPE_ID === '2'
        ? mainSearchDisabled && !searchOverrideSatisfied
        : mainSearchDisabled

    return (
      <div className={`search-box ${longDescriptionSearchPage ? 'long-descr' : ''}`}>
        <h1>
          {title}
          {showSearchLiensCheckout && loggedIn && (
            <button
              className="btn btn-primary btn-raised align-right"
              onClick={() =>
                onPurchaseRequested(this.input.value, this.state.advancedParameterValues)
              }
              disabled={!hasResults}
            >
              Purchase Search
            </button>
          )}
          {allowSearchPrint ? (
            <button
              className="btn btn-primary btn-raised align-right print-button"
              onClick={(e) => this.search(e, {offset: 0, print: true})}
              disabled={!hasResults}
            >
              <PrintIcon /> Print
            </button>
          ) : null}
        </h1>
        {description && <ReactMarkdown source={description} className="markdown description" />}
        {limitDescription && <ReactMarkdown source ={limitDescription} className="limit-Description"/>}
        <div>
          <br />
        </div>
        <div className="search-input-wrapper">
          <div className="inner-input-wrapper">
            <form onSubmit={this.search}>
              <input
                ref={(ref) => {
                  this.input = ref
                }}
                type="text"
                onFocus={this.selectSearch}
                onChange={this.trimValue}
                placeholder={placeholder}
                className="search-input"
                disabled={searching}
                aria-label={placeholder}
                defaultValue={defaultValue}
              />
            </form>
          </div>
          {!searching ? (
            <React.Fragment>
              <button
                className={`search-button ${this.state.drawerIsOpen ? 'hide' : ''}`}
                onClick={!searchDisabled ? this.search : undefined}
                aria-label="Execute search"
                aria-disabled={searchDisabled}
                aria-hidden={this.state.drawerIsOpen}
                tabIndex={this.state.drawerIsOpen ? -1 : undefined}
                aria-busy={searching}
                aria-invalid={searchDisabled}
                aria-describedby="search-disabled-hint"
              >
                <span className="icon icon-zoom-medium" />
              </button>
              <p id="search-disabled-hint" aria-live="polite">
                {searchDisabled ? (
                  <span className=" visually-hidden">
                    Please provide valid search criteria to perform a search.
                  </span>
                ) : null}
              </p>
            </React.Fragment>
          ) : (
            <Spinner className="search-loader" themeColor="medium-neutral" linear size="medium" />
          )}
          {advancedParameters && (
            <AdvancedParameters
              key={category}
              ref={(ref) => {
                this.parameters = ref
              }}
              parameters={advancedParameters}
              values={this.state.advancedParameterValues}
              open={this.state.drawerIsOpen}
              onSearchRequested={!searchDisabled ? this.search : undefined}
              onRequestToggleDrawer={(open, callback) => {
                this.setState(
                  (state) => ({ drawerIsOpen: open !== undefined ? open : !state.drawerIsOpen }),
                  () => {
                    if (!this.state.drawerIsOpen) {
                      this.input.focus()
                    }
                    if (callback) {
                      callback(this.state.drawerIsOpen)
                    }
                  }
                )
              }}
              clearFilters={this.clearFilters}
              onChange={this.setAdvanceParameterValues}
              startOpen={advancedParametersStartOpen}
              searchDisabled={searchDisabled}
              searching={searching}
            />
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Search/Search.js